import http from "./http.js";

async function getDepartments(page = 1, rowsPerPage = 9, search = "") {
  try {
    const response = await http.get(
      `departments?page=${page}&pageSize=${rowsPerPage}&searchTerm=${search}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function getDepartment(id) {
  try {
    const response = await http.get(`departments/${id}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function updateDepartment(id, department) {
  try {
    const response = await http.put(`departments/${id}`, { title: department });
    return response;
  } catch (err) {
    throw err;
  }
}

async function createDepartment(department) {
  try {
    const response = await http.post("departments", { title: department });
    return response;
  } catch (err) {
    throw err;
  }
}

export {
  getDepartments,
  getDepartment,
  updateDepartment,
  createDepartment,
};
